/**
 * Minimum interval threshold in milliseconds.
 * Intervals at or below this threshold are excluded from dead air tracking.
 */
export const MINIMUM_INTERVAL_THRESHOLD_MS = 20;
